import { LoginService } from './../../../service/login.service';
import { InfoService } from './../../../service/info.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-horarios',
  templateUrl: './horarios.component.html',
  styleUrls: ['./horarios.component.scss']
})
export class HorariosComponent implements OnInit {
  msjError: any;
  session: any;

  constructor(private infoService: InfoService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }

  filter = '';
  horario: any[];
  numParametro: number;
  error: boolean;
  loading: boolean;

  ngOnInit(): void {
    this.msjError = '';
    this.error = false;
    this.loading = false;
    this.numParametro = 13055; //TODO: cambiar parametro

    this.getHorarios();
  }

  getHorarios() {
    let json = {
      idSesion: this.session.ksi,
      numParametro: this.numParametro
    }
    this.loading = true;
    this.infoService.getInfo(json).subscribe(res => {
      if (res) {
        if (res.numError === 1) {
          this.horario = res.info;
          this.loading = false;
        }
        else {
          this.loading = false;
          this.error = true;
          this.msjError = res.msjError;
        }
      }
    },
      () => {
        this.loading = false;
        this.error = true;
        this.msjError = "Error al obtener horarios. Intente más tarde.";
      })
  }
}